const loginPage = Vue.component("login", {

	template: '<div class="login"><navbar-element :title="title" :showGridButton="false" :showUserButton="false"/><el-form class="login-form" ref="form" :model="form" v-on:submit.prevent="login" method="POST"><el-form-item :label=" \'statistic.login.username\' | t "><el-input v-model="form.username" @keyup.enter="login" name="username" type="username" auto-complete="on" autofocus/></el-form-item><el-form-item :label=" \'statistic.login.password\' | t"><el-input v-model="form.password" @keyup.enter="login" name="password" type="password"/></el-form-item><el-form-item><el-button type="primary" native-type="submit" @click.prevent="login" class="submitButton"   :loading="isLoading">{{ \'statistic.login.login\' | t }}</el-button></el-form-item></el-form></div>',

	data: function () {
		return {
			isLoading: false,
			form: {
				email: "",
				password: "",
				remainSignedIn: false
			},
			passwordDialogVisible: false,
			passwordDialogLoading: false,
			passwordForm: {
				email: "",
			},
			title: t("statistic.login_page.title")
		}
	},
	created: function(){
	},
	methods: {

		login: function () {

			// Validate fields
			if (this.form.username === "" || this.form.password === "") {
				this.$message({
					message: t("statistic.login.missing.fields"),
					type: "error"
				});
				return;
			}

			this.isLoading = true;

			session.login(
					this.form.username,
					this.form.password,
					this.form.remainSignedIn
				)
				.then(response => {
                    this.isLoading = false;
                    this.$router.replace({
                        name: "graph"
                    });

				})
				.catch(error => {
					this.isLoading = false;
					this.$message({
						message: error.message,
						type: "error"
					});
				});
		},
	}
});
